export const colors = {
  brand: {
    blue: "#1E497E",
    blueLight: "#EFF5FA",
    blue100: "#CCDEEE",
    brownLight: "#D6CBBA",
    brown: "#CCAF7F",
    brownDark: "#A38C66",
  },
  blue: {
    50: "#EFF5FA",
    100: "#CCDEEE",
    200: "#99BEDD",
    300: "#669DCB",
    400: "#337DBA",
    500: "#1E497E",
    600: "#0F243E",
    700: "#003765",
    800: "#002544",
    900: "#001222",
  },
  gray: {
    white: "#FFFFFF",
    50: "#F4F4F4",
    100: "#D6D6D6",
    200: "#ADADAD",
    300: "#858585",
    400: "#5C5C5C",
    500: "#333333",
    600: "#292929",
    700: "#1F1F1F",
    800: "#141414",
    900: "#1A1A1A",
    black: "#000000",
  },
  green: {
    100: "#F6FFED",
    200: "#D6F7BE",
    300: "#D7EB8F",
    400: "#85DE64",
    500: "#73D13D",
    600: "#52C41A",
    700: "#389E0D",
    800: "#135200",
    900: "#092B00",
  },
  orange: {
    100: "#FBEADA",
    200: "#F7D486",
    300: "#F3BF91",
    400: "#EEA68C",
    500: "#EA9448",
    600: "#E67E23",
    700: "#C0801D",
    800: "#995417",
    900: "#733F12",
  },
  red: {
    100: "#FBE1DE",
    200: "#F7C3BE",
    300: "#F8A69E",
    400: "#EF877D",
    500: "#EB695D",
    600: "#E74B3C",
    700: "#C13F32",
    800: "#9A3228",
    900: "#74261E",
    1000: "#5C0011",
  },
} as const;

export type Colors = typeof colors;
